module.exports = __webpack_public_path__ + "media/headerBg.fa0cb368.mp4";